import { render, staticRenderFns } from "./HistorySection.vue?vue&type=template&id=4f6371db&scoped=true"
import script from "./HistorySection.vue?vue&type=script&lang=js"
export * from "./HistorySection.vue?vue&type=script&lang=js"
import style0 from "./HistorySection.vue?vue&type=style&index=0&id=4f6371db&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6371db",
  null
  
)

export default component.exports